<div class="qu-container">

  <!-- ─── Header ─── -->
  <div class="qu-header">
    <div class="qu-header-left">
      <span class="material-icons qu-header-icon" aria-hidden="true">school</span>
      <div>
        <h2 class="qu-title">{{ 'CB_TRAINING_DATA' | translate }}</h2>
        <p class="qu-subtitle">{{ 'CB_TRAINING_DATA_SUBTITLE' | translate }}</p>
      </div>
    </div>
  </div>

  <!-- ─── Action Bar ─── -->
  <div class="qu-action-bar">

    <!-- Search (left) -->
    <div class="qu-search-wrap">
      <input
        type="text"
        [(ngModel)]="search"
        (ngModelChange)="onSearchChange()"
        placeholder="Search questions or answers..."
        class="qu-input qu-input-search"
      />
      <button *ngIf="search" (click)="search = ''; page = 1" class="qu-clear-btn">&#x2715;</button>
    </div>

    <div class="btn-group">
      <button class="qu-btn qu-btn-secondary" (click)="fileInput.click()">
      Upload Excel
      </button>

      <input
        #fileInput
        type="file"
        accept=".xlsx,.xls"
        hidden
        (change)="onFileSelected($event)"/>
      <!-- Add (right) -->
      <button class="qu-btn qu-btn-primary" (click)="openAddModal()">+ Add</button>
    </div>
  </div>

  <!-- ─── Table ─── -->
  <div class="qu-table-wrap">

    <!-- Skeleton (loading) -->
    <table *ngIf="loading" class="qu-table">
      <thead>
        <tr>
          <th class="qu-th qu-th-num">#</th>
          <th class="qu-th">Question</th>
          <th class="qu-th">Answer</th>
          <th class="qu-th qu-th-abusive">Abusive</th>
          <th class="qu-th qu-th-action">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let sk of skeletonRows" class="qu-skeleton-row">
          <td class="qu-td"><div class="qu-sk qu-sk-xs"></div></td>
          <td class="qu-td"><div class="qu-sk"></div></td>
          <td class="qu-td"><div class="qu-sk"></div></td>
          <td class="qu-td"><div class="qu-sk qu-sk-md"></div></td>
          <td class="qu-td"><div class="qu-sk qu-sk-md"></div></td>
        </tr>
      </tbody>
    </table>

    <!-- Data Table -->
    <table *ngIf="!loading" class="qu-table">
      <thead>
        <tr>
          <th class="qu-th qu-th-num">#</th>
          <th class="qu-th">Question</th>
          <th class="qu-th">Answer</th>
          <th class="qu-th qu-th-abusive">Abusive</th>
          <th class="qu-th qu-th-action">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let row of pageData; let idx = index"
          class="qu-tr"
          [ngClass]="getRowClass(idx)">

          <td class="qu-td qu-td-num">{{ getRowIndex(idx) }}</td>

          <td class="qu-td">{{ getQuestion(row) }}</td>

          <td class="qu-td">{{ getAnswer(row) }}</td>

          <td class="qu-td qu-td-abusive">
            <span class="qu-abusive-badge" [ngClass]="row.abusive ? 'qu-abusive-yes' : 'qu-abusive-no'">
              {{ row.abusive ? 'Yes' : 'No' }}
            </span>
          </td>

          <td class="qu-td qu-td-action">
            <button class="qu-icon-btn qu-icon-btn-edit" (click)="openEditModal(row)" title="Edit query">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
              </svg>
            </button>
            <button class="qu-icon-btn qu-icon-btn-delete" (click)="confirmDeleteRow(row)" title="Delete query">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="3 6 5 6 21 6"/>
                <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
                <path d="M10 11v6M14 11v6"/>
                <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
              </svg>
            </button>
          </td>
        </tr>

        <tr *ngIf="pageData.length === 0">
          <td colspan="5" class="qu-td qu-td-empty">No results found.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- ─── Pagination ─── -->
  <div class="qu-pagination">
    <div class="qu-page-nav">
      <button class="qu-btn qu-btn-page" [disabled]="page === 1" (click)="page = page - 1">Prev</button>
      <button class="qu-btn qu-btn-page" [disabled]="page === totalPages" (click)="page = page + 1">Next</button>
      <span class="qu-page-info">Page {{ page }} of {{ totalPages }}</span>
    </div>

    <!-- Row count (center) -->
    <span class="qu-count">
      <ng-container *ngIf="search">{{ filtered.length }} of {{ data.length }} queries</ng-container>
      <ng-container *ngIf="!search">{{ data.length }} queries</ng-container>
    </span>

    <div class="qu-rows-wrap">
      <span class="qu-label">Rows per page</span>
      <select [(ngModel)]="rowsPerPage" (ngModelChange)="page = 1" class="qu-select">
        <option [value]="5">5</option>
        <option [value]="10">10</option>
        <option [value]="25">25</option>
        <option [value]="50">50</option>
      </select>
    </div>
  </div>

</div>

<!-- ─── Add Query Modal ─── -->
<div *ngIf="showAddModal" class="qu-overlay">
  <div class="qu-add-modal" (click)="$event.stopPropagation()">

    <!-- Modal Header -->
    <div class="qu-add-header">
      <div class="qu-add-header-icon">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
        </svg>
      </div>
      <span class="qu-add-title">Add New Query</span>
      <button class="qu-close-btn" (click)="closeAddModal()">&#x2715;</button>
    </div>

    <!-- Modal Body -->
    <div class="qu-add-body">
      <div class="qu-field">
        <label class="qu-field-label" for="newQuestion">Question</label>
        <textarea
          id="newQuestion"
          [(ngModel)]="newQuestion"
          placeholder="Enter question..."
          class="qu-textarea"
          rows="3">
        </textarea>
      </div>
      <div class="qu-field">
        <label class="qu-field-label" for="newAnswer">Answer</label>
        <textarea
          id="newAnswer"
          [(ngModel)]="newAnswer"
          placeholder="Enter answer..."
          class="qu-textarea"
          rows="4">
        </textarea>
      </div>
      <div class="qu-field qu-field-inline">
        <span class="qu-field-label">Abusive</span>
        <label class="qu-toggle">
          <input type="checkbox" [(ngModel)]="newAbusive" />
          <span class="qu-toggle-slider"></span>
        </label>
      </div>
    </div>

    <!-- Modal Footer -->
    <div class="qu-add-footer">
      <button class="qu-btn qu-btn-secondary" (click)="closeAddModal()">Cancel</button>
      <button class="qu-btn qu-btn-primary" (click)="handleAdd()">Add Query</button>
    </div>
  </div>
</div>

<!-- ─── Edit Query Modal ─── -->
<div *ngIf="showEditModal" class="qu-overlay">
  <div class="qu-add-modal" (click)="$event.stopPropagation()">

    <!-- Modal Header -->
    <div class="qu-add-header">
      <div class="qu-add-header-icon">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
        </svg>
      </div>
      <span class="qu-add-title">Edit Query</span>
      <button class="qu-close-btn" (click)="closeEditModal()">&#x2715;</button>
    </div>

    <!-- Modal Body -->
    <div class="qu-add-body">
      <div class="qu-field">
        <label class="qu-field-label" for="editQuestion">Question</label>
        <textarea
          id="editQuestion"
          [(ngModel)]="editQuestion"
          placeholder="Enter question..."
          class="qu-textarea"
          rows="3">
        </textarea>
      </div>
      <div class="qu-field">
        <label class="qu-field-label" for="editAnswer">Answer</label>
        <textarea
          id="editAnswer"
          [(ngModel)]="editAnswer"
          placeholder="Enter answer..."
          class="qu-textarea"
          rows="4">
        </textarea>
      </div>
      <div class="qu-field qu-field-inline">
        <span class="qu-field-label">Abusive</span>
        <label class="qu-toggle">
          <input type="checkbox" [(ngModel)]="editAbusive" />
          <span class="qu-toggle-slider"></span>
        </label>
      </div>
    </div>

    <!-- Modal Footer -->
    <div class="qu-add-footer">
      <button class="qu-btn qu-btn-secondary" (click)="closeEditModal()">Cancel</button>
      <button class="qu-btn qu-btn-primary" (click)="handleEdit()">Update Query</button>
    </div>
  </div>
</div>

<!-- ─── Confirm Delete Modal ─── -->
<div *ngIf="showDeleteModal" class="qu-overlay" (click)="showDeleteModal = false">
  <div class="qu-modal" (click)="$event.stopPropagation()">
    <p class="qu-modal-msg">
      Are you sure you want to delete this query?
      This action cannot be undone.
    </p>
    <div class="qu-modal-actions">
      <button class="qu-btn qu-btn-secondary" (click)="showDeleteModal = false">Cancel</button>
      <button class="qu-btn qu-btn-danger" (click)="handleDelete()">Delete</button>
    </div>
  </div>
</div>

<!-- ─── Toasts ─── -->
<div class="qu-toasts">
  <div
    *ngFor="let t of toasts"
    class="qu-toast"
    [ngClass]="t.type === 'success' ? 'qu-toast-success' : 'qu-toast-error'">
    <span class="qu-toast-icon" [ngClass]="t.type === 'success' ? 'qu-icon-success' : 'qu-icon-error'">
      {{ t.type === 'success' ? '✓' : '✕' }}
    </span>
    <span class="qu-toast-text">{{ t.message }}</span>
  </div>
</div>

<div *ngIf="showPreviewModal" class="preview-overlay">

  <div class="preview-modal">

    <h1>Excel Preview</h1>

    <div class="preview-table-wrapper">
      <table class="preview-table">
        <thead>
          <tr>
            <th>Question</th>
            <th>Answer</th>
            <th>Abusive</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let row of previewData">
            <td>{{ row.question }}</td>
            <td>{{ row.answer }}</td>
            <td>{{ row.is_abusive }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="preview-actions">
      <button class="qu-btn qu-btn-secondary" (click)="cancelPreview()">
        Cancel
      </button>

      <button class="qu-btn qu-btn-primary" (click)="confirmUpload()">
        Confirm Upload
      </button>
    </div>

  </div>

</div>